import type React from "react";

import type { TypographyVariant } from "@mui/material";
import { Stack, Typography } from "@mui/material";
import type { TypographyPropsVariantOverrides } from "@mui/material/Typography";

import { DARK_BLUE } from "theme/colors";

interface SummaryBoxProps {
  backgroundColor?: string;
  children?: React.ReactNode;
  label?: string;
  labelColor?: string;
  padding?: number | string;
  value?: React.ReactNode;
  valueColor?: string;
  valueTypographyVariant?: TypographyVariant | keyof TypographyPropsVariantOverrides;
}

export const SummaryBox: React.FC<SummaryBoxProps> = ({
  backgroundColor = DARK_BLUE[5],
  children,
  label,
  labelColor = DARK_BLUE[80],
  padding = 1.5,
  value,
  valueColor = DARK_BLUE[100],
  valueTypographyVariant = "h4",
}) => {
  return (
    <Stack
      spacing={0.5}
      padding={padding}
      sx={{ backgroundColor, borderRadius: 1, boxSizing: "border-box", justifyContent: "center", minHeight: 40 }}
    >
      {label && (
        <Typography variant="caption" color={labelColor}>
          {label}
        </Typography>
      )}
      {value !== null && value !== undefined && (
        <Typography variant={valueTypographyVariant} color={valueColor}>
          {value}
        </Typography>
      )}
      {children}
    </Stack>
  );
};
